exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.page--generate_reports .btn--loader .btn__content {\n  opacity: 1;\n}\n.page--generate_reports .btn--loader .btn__content .icon {\n    opacity: 0;\n}\n.page--generate_reports .btn--loader .btn__loading {\n  width: 55px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1350a8ec","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/GenerateReports.vue
// module id = FjuS
// module chunks = 1